import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enJson from "./utils/locale/en.json";
import thJson from "./utils/locale/th.json";
import zhJson from "./utils/locale/zh.json";
import deJson from "./utils/locale/de.json";
import esJson from "./utils/locale/es.json";
import frJson from "./utils/locale/fr.json";
import itJson from "./utils/locale/it.json";
import jpJson from "./utils/locale/jp.json";
import koJson from "./utils/locale/ko.json";
import svJson from "./utils/locale/sv.json";
import trJson from "./utils/locale/tr.json";
import twJson from "./utils/locale/tw.json";
import vnJson from "./utils/locale/vn.json";
import hkJson from "./utils/locale/hk.json";
import noJson from "./utils/locale/no.json";
import { config } from "./config/global";
import { constant } from "./config/constant";
import { getLangFromUrl } from "./utils/helper";
import { getRopEnableSuccess, getRopEnableFailure, getRopEnableDataPending } from "./OSCI/src/slice/ropEnablementSlice";
const isPSMPath = () => {
  const p = (typeof window !== 'undefined' ? window.location.pathname : '')?.toLowerCase() || '';
  const re = new RegExp('^(\\/[a-z]{2}(?:-[a-z]{2})?)?' + '(\\/[a-z-]+)?' + '\\/more-services\\/' + '(?:' + 'pre-select-meals(?:\\/.*)?' + '|' + 'preselect-meals\\/meal-selection(?:\\/.*)?' + ')' + '$');
  return re.test(p);
};
const isThaiCode = lng => {
  const c = (lng || '').toLowerCase();
  return c.startsWith('th');
};
const langDetector = new LanguageDetector();
langDetector.addDetector({
  name: "customPathDetector",
  lookup(options) {
    let found;
    if (typeof window !== "undefined") {
      const language = window?.location?.pathname?.match(/\/([a-zA-Z-]*)/g);
      if (language instanceof Array) {
        if (typeof options?.lookupFromPathIndex === "number") {
          if (typeof language[options?.lookupFromPathIndex] !== "string") {
            return undefined;
          }
          found = language[options.lookupFromPathIndex].replace("/", "");
        } else {
          found = language[options.lookupFromPathIndex].replace("/", "");
        }
      }
    }
    return found;
  },
  cacheUserLanguage(lng, options) {}
});
const getCookie = name => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.startsWith(name + "=")) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
};
const getFallBackLang = async () => {
  try {
    const geoUrl = config.GEOLOCATION;
    const geolocationUrl = `${process.env.REACT_APP_TG_API_BASE_URL}${geoUrl}`;
    const nonENMarket = constant?.nonEngMarketLists;
    const allMarkets = constant?.supportedMarket;
    const getFromPath = isDapiPath() ? getLangFromUrl() : window.location.pathname?.split("/")?.[1];
    const getFromCookie = getCookie("i18next") ?? "";
    const lang = getFromPath?.length > 1 ? getFromPath : getFromCookie.length > 0 ? getFromCookie : "";
    const res = lang !== undefined && lang !== "" && lang !== null ? lang : await fetch(geolocationUrl);
    const allHeaders = lang !== undefined && lang !== "" && lang !== null ? lang : Object.fromEntries(res.headers.entries());
    const countryCode = lang !== undefined && lang !== "" && lang !== null ? lang : allHeaders["cloudfront-viewer-country"];
    const langCode = lang !== undefined && lang !== "" && lang !== null ? lang : allMarkets.includes(countryCode?.toLowerCase()) ? nonENMarket?.includes(countryCode?.toLowerCase()) ? `${countryCode?.toLowerCase()}-${countryCode?.toLowerCase()}` : `en-${countryCode?.toLowerCase()}` : "en-th";
    return langCode;
  } catch (e) {
    return "en-th";
  }
};
const getBaseLang = lng => {
  const parts = lng?.split("-");
  return parts?.reverse()?.join("/") || lng;
};
const FallBack_Language = "en-th";
const dapiPaths = ["/booking/", "/managebooking/"];
const resources = {
  "en-th": {
    ...enJson
  },
  "th-th": {
    ...thJson
  },
  "en-au": {
    ...enJson
  },
  "en-bd": {
    ...enJson
  },
  "en-kh": {
    ...enJson
  },
  "en-cn": {
    ...enJson
  },
  "zh-cn": {
    ...zhJson
  },
  "en-in": {
    ...enJson
  },
  "en-id": {
    ...enJson
  },
  "en-jp": {
    ...enJson
  },
  "ja-jp": {
    ...jpJson
  },
  "en-kr": {
    ...enJson
  },
  "ko-kr": {
    ...koJson
  },
  "en-la": {
    ...enJson
  },
  "en-my": {
    ...enJson
  },
  "en-mm": {
    ...enJson
  },
  "en-np": {
    ...enJson
  },
  "en-nz": {
    ...enJson
  },
  "en-pk": {
    ...enJson
  },
  "en-ph": {
    ...enJson
  },
  "en-sg": {
    ...enJson
  },
  "en-lk": {
    ...enJson
  },
  "en-tw": {
    ...enJson
  },
  "zh-tw": {
    ...twJson
  },
  "en-vn": {
    ...enJson
  },
  "vi-vn": {
    ...vnJson
  },
  "en-hk": {
    ...enJson
  },
  "en-be": {
    ...enJson
  },
  "en-dk": {
    ...enJson
  },
  "fr-fr": {
    ...frJson
  },
  "de-de": {
    ...deJson
  },
  "it-it": {
    ...itJson
  },
  "en-no": {
    ...enJson
  },
  "no-no": {
    ...noJson
  },
  "es-es": {
    ...esJson
  },
  "en-se": {
    ...enJson
  },
  "sv-se": {
    ...svJson
  },
  "en-ch": {
    ...enJson
  },
  "tr-tr": {
    ...trJson
  },
  "en-gb": {
    ...enJson
  },
  "en-ca": {
    ...enJson
  },
  "en-us": {
    ...enJson
  },
  "zh-hk": {
    ...hkJson
  },
  "en-nl": {
    ...enJson
  }
};
const fetchLabels = async (lng, isRop) => {
  try {
    const labelUrl = !isRop ? `${process.env.REACT_APP_TG_API_BASE_URL}${config.REACT_APP_DAPI_TG_AEM_BASE_URL}${lng}${config.REACT_APP_DAPI_TG_LOCALLABEL_BASE_URL}` : `${process.env.REACT_APP_TG_API_BASE_URL}${config.ROP_TG_AEM_BASE_URL}${lng}${config.ROP_TRANSLATION_JSON}`;
    const res = await fetch(labelUrl);
    if (!res.ok) return {};
    return await res.json();
  } catch {
    return {};
  }
};
const fetchOsciLabels = async lng => {
  try {
    const labelUrl = `${process.env.REACT_APP_TG_API_BASE_URL}${config.ROP_TG_AEM_BASE_URL}${lng}${config.REACT_APP_OSCI_LOCALLABELS_BASE_URL}`;
    const res = await fetch(labelUrl);
    if (!res.ok) return {};
    return await res.json();
  } catch {
    return {};
  }
};
const isDapiPath = () => {
  return dapiPaths?.some(item => location.pathname?.includes(item));
};
export const loadResources = async (lng, ropData) => {
  const effectiveLang = isPSMPath() ? isThaiCode(lng) ? 'th-th' : 'en-th' : lng;
  const baseLang = getBaseLang(effectiveLang);
  const fallbackLanguage = getBaseLang(FallBack_Language);
  let currentLang;
  let currentLangTranslation;
  let ropLang;
  let ropCurrentLang;
  let osciLang;
  let osciLangTranslation;
  const loadOsciLabels = true;
  if (window.location.pathname.includes("/booking/")) {
    sessionStorage.setItem("isBookingMarket", lng);
  }
  if (window.location.pathname.includes("/managebooking/")) {
    sessionStorage.setItem("isMMBLang", lng);
  }
  // if (loadOsciLabels) {
  //   osciLang = await fetchOsciLabels(baseLang);
  //   osciLangTranslation = osciLang?.translation;
  // }
  if (!isDapiPath()) {
    currentLang = await fetchLabels(baseLang, false);
    currentLangTranslation = currentLang.translation;
  }
  if (ropData?.ropEnabledData?.webRopEnabled) {
    ropLang = await fetchLabels(baseLang, true);
    ropCurrentLang = ropLang.translation;
  }
  let fallBackLang = {};
  let fallBackLangTranslation = {};
  let localCurrentLang = {};
  let localCurrentLangTranslation = {};
  let localRopFallBack = {};
  let localRopLanTranslation = {};
  let localEngFallBack = {};
  let localEngLanTranslation = {};
  let osciEngFallBack = {};
  let osciEngFallbackTranslation = {};
  if (effectiveLang !== FallBack_Language && !isDapiPath()) {
    fallBackLang = await fetchLabels(fallbackLanguage, false);
    fallBackLangTranslation = fallBackLang.translation;
  }
  if (ropData?.ropEnabledData?.webRopEnabled && effectiveLang !== FallBack_Language) {
    localRopFallBack = await fetchLabels(fallbackLanguage, true);
    localRopLanTranslation = localRopFallBack.translation;
  }

  // if (effectiveLang !== FallBack_Language && !isDapiPath()) {
  //   osciEngFallBack = await fetchOsciLabels(fallbackLanguage);
  //   osciEngFallbackTranslation = osciEngFallBack.translation;
  // }

  if (resources[effectiveLang]) {
    localCurrentLang = resources[effectiveLang];
    localCurrentLangTranslation = localCurrentLang.translation;
  }
  if (effectiveLang !== FallBack_Language) {
    localEngFallBack = resources[fallbackLanguage];
    localEngLanTranslation = localEngFallBack?.translation;
  }
  const mergedLabels = {
    ...localEngLanTranslation,
    // Local Fallback Json (en)
    ...localCurrentLangTranslation,
    // Local Json (eg: th-th)
    ...fallBackLangTranslation,
    // Dapi Checkin Fallback Json (en-th)
    ...currentLangTranslation,
    // Dapi Checkin Json (eg: th-th)
    // ...osciEngFallbackTranslation, // Osci Fallback Json (eg: en-th)
    // ...osciLangTranslation, // Osci Json (th-th)
    ...localRopLanTranslation,
    // Rop Fallback Json (en-th)
    ...ropCurrentLang // Rop Json (eg: th-th)
  };
  return mergedLabels;
};
const isRopEnabled = async lang => {
  const {
    store
  } = await import('./store');
  const state = store.getState();
  if (state?.osciReducer?.ropEnable?.hasData) {
    return state.osciReducer.ropEnable;
  }
  const baseLang = getBaseLang(lang);
  const ropURL = `${process.env.REACT_APP_TG_API_BASE_URL}${config.ROP_TG_AEM_BASE_URL}${baseLang}${config.ROP_ENABLE_JSON}`;
  const fallbackURL = `${process.env.REACT_APP_TG_API_BASE_URL}${config.ROP_TG_AEM_BASE_URL}th/en${config.ROP_ENABLE_JSON}`;
  store.dispatch(getRopEnableDataPending());
  const tryFetch = async url => {
    const res = await fetch(url);
    if (!res.ok) {
      const err = new Error(`Request failed: ${res.status}`);
      err.status = res.status;
      throw err;
    }
    return res.json();
  };
  try {
    const data = await tryFetch(ropURL);
    store.dispatch(getRopEnableSuccess(data));
    return store.getState().osciReducer.ropEnable;
  } catch (primaryErr) {
    try {
      const fallbackData = await tryFetch(fallbackURL);
      store.dispatch(getRopEnableSuccess(fallbackData));
      return store.getState().osciReducer.ropEnable;
    } catch (fallbackErr) {
      store.dispatch(getRopEnableFailure({
        response: {
          status: fallbackErr.status ?? 'unknown',
          data: null
        }
      }));
      return store.getState().osciReducer.ropEnable;
    }
  }
};
export async function initI18n() {
  const detectedLang = await getFallBackLang();
  const effectiveLang = isPSMPath() ? isThaiCode(detectedLang) ? "th-th" : "en-th" : detectedLang;
  const checkRopEnabled = await isRopEnabled(effectiveLang);
  const isRop = checkRopEnabled?.ropEnabledData?.webRopEnabled;
  sessionStorage?.setItem("isROPEnabled", isRop);
  const mergedResources = await loadResources(effectiveLang, checkRopEnabled);
  await i18n?.use(initReactI18next)?.use(langDetector)?.init({
    resources: {
      [effectiveLang]: {
        translation: mergedResources
      }
    },
    supportedLngs: ["en-th", "th-th", "en-au", "en-bd", "en-kh", "en-cn", "zh-cn", "en-in", "en-id", "en-jp", "ja-jp", "en-kr", "ko-kr", "en-la", "en-my", "en-mm", "en-np", "en-nz", "en-pk", "en-ph", "en-sg", "en-lk", "en-tw", "zh-tw", "en-vn", "vi-vn", "en-hk", "zh-hk", "en-be", "en-dk", "fr-fr", "de-de", "it-it", "en-no", "es-es", "en-se", "sv-se", "en-ch", "tr-tr", "en-gb", "en-ca", "en-us", "no-no", "en-nl"],
    fallbackLng: code => {
      if (isPSMPath()) {
        const c = (code || '').toLowerCase();
        return isThaiCode(c) ? ['th-th'] : ['en-th'];
      }
      return [detectedLang, 'en-th'];
    },
    lowerCaseLng: true,
    detection: {
      order: ["customPathDetector", "cookie"],
      lookupFromPathIndex: 0,
      caches: ["cookie"]
    },
    interpolation: {
      escapeValue: false
    },
    ns: ["translation"],
    defaultNS: "translation",
    react: {
      useSuspense: true
    }
  });
  return i18n;
}
initI18n();
export default i18n;